import { rootReducer } from "../reducers/rootReducer";
import { createStore, applyMiddleware, compose, Store, Action, AnyAction, Dispatch } from "redux";
import { StoreStructure } from "../structures";
import multi from 'redux-multi'
import storage from 'redux-persist/lib/storage'
import hardSet from 'redux-persist/lib/stateReconciler/hardSet'
import { persistStore, persistReducer } from 'redux-persist'
import { PersistPartial } from "redux-persist/es/persistReducer"

declare var window

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({trace: true, traceLimit: 25}) || compose;



const persistConfig = {
  key: 'root',
  storage,
  stateReconciler: hardSet,
}

const persistedReducer = persistReducer<StoreStructure>(persistConfig, rootReducer)

type MultiDispatch<A extends AnyAction = AnyAction> = Dispatch<A> & ((actions: A[]) => A[]);

type StoreType = Store<StoreStructure & PersistPartial, AnyAction> & {
  dispatch: MultiDispatch
}

const store: StoreType = createStore(persistedReducer, composeEnhancers(
    applyMiddleware(
        multi
    )
))

window.store = store

const persistor = persistStore(store)

export {store, persistor}

